import React, { useState } from 'react';

const BillingAnalytics = () => {
    const [showTooltip, setShowTooltip] = useState(false);

    return (
        <div 
            className="mx-auto bg-white relative"
            onMouseEnter={() => setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
        >
            {showTooltip && (
                <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-20 ">
                    <div className="bg-white px-4 py-2 rounded-lg shadow-lg">
                        <p className="text-gray-800 font-medium">Work In Progress</p>
                    </div>
                </div>
            )}

            <div className="flex items-center justify-center gap-4 mb-6">
                <div
                    className="flex items-center justify-center w-10 h-10 rounded-full"
                    style={{
                        background: "linear-gradient(180deg, #FFA782 0%, #FC583D 100%)",
                    }}
                >
                    <img
                        src={`${process.env.PUBLIC_URL}/images/desktop/step.svg`}
                        alt="Icon"
                        className="w-6 h-6"
                    />
                </div>

                <h2
                    className="text-xl text-black font-medium"
                    style={{
                        fontFamily: "Montserrat",
                        lineHeight: "29.26px",
                    }}
                >
                    Billing Analytics
                </h2>
            </div>

            <select className="w-38 p-2 mb-6 mx-auto block border border-cyan-600 text-sm rounded-lg bg-white">
                <option value="last7days">Last 7 Days</option>
                <option value="last30days">Last 30 Days</option>
                <option value="last90days">Last 90 Days</option>
            </select>

            <div className="space-y-4">
                <div className="bg-white border border-cyan-400 p-4 rounded">
                    <div className="flex items-center justify-center gap-2 mb-2">
                        <img src="/images/desktop/alert-outline.svg" alt="alert" className="w-5 h-5" />
                        <h3 className="text-lg text-gray-600">Count of Outstanding Invoices</h3>
                    </div>
                    <div className="text-center">
                        <div className="text-2xl font-medium">56</div>
                        <div className="text-sm text-gray-500">Outstanding Invoices</div>
                    </div>
                </div>

                <div className="bg-white border border-cyan-400 p-4 rounded">
                    <div className="flex items-center justify-center gap-2 mb-2">
                        <img src="/images/desktop/money-circle.svg" alt="money" className="w-5 h-5" />
                        <h3 className="text-lg text-gray-600">Total Receivables Pending</h3>
                    </div>
                    <div className="text-center">
                        <div className="text-2xl font-medium">56,262</div>
                        <div className="text-sm text-gray-500">INR</div>
                    </div>
                </div>

                <div className="bg-white border border-cyan-400 p-4 rounded">
                    <div className="flex items-center justify-center gap-2 mb-2">
                        <img src="/images/desktop/alert-outline.svg" alt="alert" className="w-5 h-5" />
                        <h3 className="text-lg text-gray-600">Count of Overdue Invoices</h3>
                    </div>
                    <div className="text-center">
                        <div className="text-2xl font-medium">56</div>
                        <div className="text-sm text-gray-500">Overdue Invoices</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BillingAnalytics;